var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardRankTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_2642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5644 14.3563L26.0156 12.6247C27.9103 12.0244 29.1831 10.2844 29.1831 8.29492V3.75391H26.4585V2.8457C26.4585 2.34413 26.8652 1.9375 27.3667 1.9375H30.9995V8.29492C30.9995 9.67254 30.566 10.9834 29.7459 12.086C28.9423 13.1663 27.8422 13.9514 26.5644 14.3563Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43512 14.3563C3.15734 13.9513 2.0572 13.1663 1.25362 12.086C0.433516 10.9834 0 9.67248 0 8.29492V1.9375H3.63281C4.13438 1.9375 4.54102 2.34413 4.54102 2.8457V3.75391H1.81641V8.29492C1.81641 10.2844 3.08928 12.0244 4.98386 12.6247L4.43512 14.3563Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 1.9375L21.8594 11.9277V23.1323L24.5773 20.471L27.3086 23.2023V1.9375H22.7676Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23633 1.9375H3.69531V23.1323L6.4132 20.471L9.14453 23.2023V11.9277L8.23633 1.9375Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6758 11.9277V0H7.32812V11.9277C7.32812 15.4201 9.53566 18.4946 12.7773 19.6366V25.5508H10.2671C8.64684 25.5508 7.32812 26.8695 7.32812 28.4897V31H23.6758V28.4897C23.6758 26.8695 22.3571 25.5508 20.7368 25.5508H18.2266V19.6366C21.4682 18.4946 23.6758 15.4195 23.6758 11.9277Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2246 19.6366V25.5508H20.7349C22.3551 25.5508 23.6738 26.8695 23.6738 28.4897V31H15.5V0H23.6738V11.9277C23.6738 15.4195 21.4663 18.4946 18.2246 19.6366Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1191 7.16525L17.2205 6.61246L15.501 3.21094L13.7814 6.61246L9.88281 7.16525L12.7055 9.85172L12.0449 13.6129L15.501 11.8389L18.957 13.6129L18.2964 9.85172L21.1191 7.16525Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2955 9.85172L18.956 13.6129L15.5 11.8389V3.21094L17.2195 6.61246L21.1181 7.16525L18.2955 9.85172Z",
    fill: "#FF9100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_2642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardRankTrophy);
export default __webpack_public_path__ + "static/media/rewardRankTrophy.35c6778f254dfe80f9deee1848e08e64.svg";
export { ForwardRef as ReactComponent };